import { backendClient } from "@/api/backendClient";

import type {
  MaintenanceTag,
  MaintenanceTagInsert,
  MaintenanceTagListQueryParams,
  MaintenanceTagUpdate,
} from "@waku-care/types/contracts/internal";

export const getMaintenanceTagById = async (id: string) => {
  const { data, error } = await backendClient.get<MaintenanceTag>(`/maintenance-tags/${id}`);
  if (error) throw error;
  return data;
};

export const getMaintenanceTags = async (params?: MaintenanceTagListQueryParams) => {
  const { data, count, error } = await backendClient.get<MaintenanceTag[]>(`/maintenance-tags`, { params });
  if (error) throw error;
  return { data, count };
};

export const createMaintenanceTag = async ({ values }: { values: MaintenanceTagInsert }) => {
  const { data, error } = await backendClient.post<MaintenanceTag>(`/maintenance-tags`, {
    body: values,
  });
  if (error) throw error;
  return data;
};

export const updateMaintenanceTagById = async ({ id, values }: { id: string; values: MaintenanceTagUpdate }) => {
  const { data, error } = await backendClient.patch<MaintenanceTag>(`/maintenance-tags/${id}`, {
    body: values,
  });
  if (error) throw error;
  return data;
};

export const deleteMaintenanceTagById = async (id: string) => {
  const { error } = await backendClient.delete<void>(`/maintenance-tags/${id}`);
  if (error) throw error;
};
